import styles from "./FilterButton.module.scss";

export const FilterButton = ({
  onClick,
  currentFilterName,
  filterName,
  btnText,
  iconCss,
}) => {
  return (
    <button
      onClick={onClick}
      className={`${styles.gridFilter} ${
        filterName === currentFilterName && styles.gridFilterActive
      }`}
      type="button"
    >
      {iconCss && <i className={iconCss}></i>} {btnText}
    </button>
  );
};
